import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {
    CAlert,
    CButton, CCardFooter, CCardHeader,
    CFormGroup,
    CInput,
    CInvalidFeedback,
    CLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSelect, CTextarea
} from "@coreui/react";
import Form, {FormApi} from "../../../components/form";
import Select from "react-select";
import {getApi} from "../../../apis/backendApis";
import {TypeOperation, TypeTermList} from "../operation";
import CIcon from "@coreui/icons-react";
import {useHistory} from "react-router-dom";
import useCustomForm from '../../../services/useCustomForm'
import useCurrentAction from "../../../services/useCurrentAction";
import TestCaseSteps from "./testCaseSteps";
import {descreverOperacao} from "./operationDisplay";
import AceEditor from "react-ace-builds";
import "react-ace-builds/webpack-resolver-min";
import '../../../scss/styles-tester.scss';

export enum ExecutorType {
    OPERATIONS = 'operations',
    SCRIPT = 'script'
}

export const ExecutorTypeList = [
    {value: ExecutorType.OPERATIONS, description: 'Operações (passo a passo)'},
    {value: ExecutorType.SCRIPT, description: 'Script Cypress (código)'}
];


const TestCaseForm = () => {

    const [listOperacoes, setListOperacoes] = useState([]);
    const [listOperacoesBase, setListOperacoesBase] = useState([]);
    const [listGroupsTest, setListGroupsTest] = useState([]);

    const [valueData, setValueData] = useState();
    const [valueTypeTerm, setValueType] = useState();
    const [valueValue, setValueValue] = useState();

    const [showModalOperation, setShowModalOperation] = useState(false);
    const [showModalPreview, setShowModalPreview] = useState(false);
    const [listMockups, setListMockups] = useState<any[]>([]);
    const [mockupPreview, setMockupPreview] = useState<any>(null);
    const [previewRunning, setPreviewRunning] = useState(false);
    const [previewResult, setPreviewResult] = useState<any>(null);
    const [mockupReferencia, setMockupReferencia] = useState<any>(null);
    const [mockupVariaveis, setMockupVariaveis] = useState<any>(null);
    const [loadingVariaveis, setLoadingVariaveis] = useState(false);
    const [copiedKey, setCopiedKey] = useState<string | null>(null);
    const [filterVariaveis, setFilterVariaveis] = useState('');
    const [showModalRecord, setShowModalRecord] = useState(false);
    const [recordUrl, setRecordUrl] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [recordError, setRecordError] = useState<string | null>(null);

    const initialCurrentOperations: any = {
        index: '',
        model: {
            "name": "",
            "params": {
                "value": ""
            }
        }
    }
    const [currentOperation, setCurrentOperation] = useState(initialCurrentOperations);
    let history = useHistory();

    const initialValues: any = {
        id: '',
        name: '',
        codigo: '',
        operacao: '',
        operations: [],
        groupTeste: {},
        executorType: ExecutorType.OPERATIONS,
        script: ''
    }
    const [formApi, setFormApi] = useState<FormApi>();
    let pathName = history.location.pathname;
    let actionPost: string = '';
    const isDuplicar: boolean = pathName.toString().includes('duplicar');
    if (isDuplicar) {
        actionPost = 'alterar/duplicar'
    }

    const {
        values,
        handleChange,
        handleSubmit,
        handleSubmitValues,
        handleChangeSuggest,
        setValues
    } = useCustomForm(
        {
            initialValues,
            route: 'test-case',
            action: actionPost,
            onSubmit: values => submitValues(values.values),
            onLoadDadosCompleted: (values) => {
                if (isDuplicar) {
                    values.name = 'CÓPIA DE ' + values.name;
                    values.codigo = '';
                }
                if (!values.executorType) {
                    values.executorType = ExecutorType.OPERATIONS;
                }
                setValues(values);
                if(values.groupTeste){
                let newData = {...values, groupTeste: {value: values.groupTeste.id , label: values.groupTeste.name}}
                setValues(newData);
                }
            }
        }
    );

    useEffect(() => {
        async function loadLists() {
            let api = getApi();
            api.get(`test-case/operations`).then((response) => {
                let data = response.data;
                setListOperacoesBase(data);
                setListOperacoes(getList(data));
            }).finally(() => {});
            api.get(`group-teste/suggest/TestCase`).then((response) => {
                let data = response.data;
                setListGroupsTest(getListGroupTest(data['groupsTeste']));
            }).finally(() => {});
            api.get(`mockup/suggest/ `).then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setListMockups(data);
            }).catch(() => {});
        }
        loadLists();
    }, []);

    const submitValues = (values: any) => {
        handleSubmitValues(values);
    }

    // ------------------------------------------------------------------ validação e cabeçalho

    const action = useCurrentAction();
    const [erros, setErros] = useState<Record<string, string>>({});

    const validar = () => {
        const encontrados: Record<string, string> = {};
        if (!String(values.codigo || '').trim()) {
            encontrados.codigo = 'Informe o código do caso de teste.';
        }
        if (!String(values.name || '').trim()) {
            encontrados.name = 'Informe o nome do caso de teste.';
        }
        if (!values.executorType) {
            encontrados.executorType = 'Escolha o tipo de executor.';
        }
        return encontrados;
    }

    // Mensagem de erro ao lado do campo, no lugar do balão do navegador (o form usa noValidate)
    const aoSalvar = (evento: any) => {
        const encontrados = validar();
        setErros(encontrados);
        const primeiro = Object.keys(encontrados)[0];
        if (primeiro) {
            evento.preventDefault();
            document.getElementById(primeiro)?.focus();
            return;
        }
        handleSubmit(evento);
    }

    const aoMudarCampo = (evento: any) => {
        handleChange(evento);
        const campo = evento.target.name;
        if (erros[campo]) {
            setErros(atual => {
                const copia = {...atual};
                delete copia[campo];
                return copia;
            });
        }
    }

    const titulo = isDuplicar ? 'Duplicar caso de teste' : (action === 'edit' ? 'Editar caso de teste' : 'Novo caso de teste');

    const handleFormReady = (formApi: FormApi) => {
        setFormApi(formApi);
    }

    // Identificador estável por operação (o índice muda ao arrastar e bagunça a animação do drag and drop)
    const idsOperacoesRef = useRef(new WeakMap<object, string>());
    const contadorOperacoesRef = useRef(0);
    const idOperacao = (operacao: any) => {
        if (!idsOperacoesRef.current.has(operacao)) {
            idsOperacoesRef.current.set(operacao, 'operacao-' + (contadorOperacoesRef.current++));
        }
        return idsOperacoesRef.current.get(operacao) as string;
    }

    const onClickCustomOperation = (operation: any, index: any) => {
        setCurrentOperation({"model": operation, "index": index});
        setValueValue(operation.params.value)
        setValueType(operation.params.type_term)
        setValueData(operation.params.data)
        setShowModalOperation(true);
    }

    const onCloseModal = () => {
        setShowModalOperation(false);
        setCurrentOperation(initialCurrentOperations);
    }

    const onConfirmeOperation = () => {
        const updatedOperation = {
            ...currentOperation.model,
            params: {
                ...currentOperation.model.params,
                type_term: valueTypeTerm,
                value: valueValue,
                data: valueData,
            },
        };
        const updatedOperations = values.operations.map((operation: any, idx: any) => idx === currentOperation.index ? updatedOperation : operation);
        setValues({ ...values, operations: updatedOperations });
        onCloseModal();
    };

    const handleChangeCurrentOperation = (event: any) => {
        const { name, value } = event.target;
        const stateSetters: Record<string, React.Dispatch<React.SetStateAction<any>>> = {
            type_term: setValueType,
            value: setValueValue,
            data: setValueData,
        };
        const setter = stateSetters[name];
        if (setter) {
            setter(value);
        }
    };

    const getList = (list: any) => {
        let data: any = [];
        (Object.keys(list) as (keyof typeof list)[]).forEach((key, index) => {
            let item: any = {};
            item['label'] = list[key]['name'];
            item['value'] = key;
            data.push(item);
        });
        return data;
    }
    const getListGroupTest = (list: any) => {
        let data: any = [];
        (Object.keys(list) as (keyof typeof list)[]).forEach((key, index) => {
            let item: any = {};
            item['label'] = list[key];
            item['value'] = key;
            data.push(item);
        });
        return data;
    }

    // Guarda {value, label}: o FormBean do backend resolve a associação pelo "value", e null tira o grupo
    const handleGroupTest = (option: any) => {
        setValues({...values, groupTeste: option ? {value: option.value, label: option.label} : null})
    }

    const handleTestScript = () => {
        setPreviewResult(null);
        // pré-seleciona o mockup de referência no modal de preview
        if (mockupReferencia && !mockupPreview) {
            setMockupPreview(mockupReferencia);
        }
        setShowModalPreview(true);
    };

    const handleMockupReferenciaChange = (opt: any) => {
        setMockupReferencia(opt);
        setMockupVariaveis(null);
        if (!opt) return;
        setLoadingVariaveis(true);
        const api = getApi();
        api.get(`test-case/mockup-preview/${opt.value}`).then((response: any) => {
            setMockupVariaveis(response.data?.mockup || {});
        }).catch(() => {
            setMockupVariaveis({});
        }).finally(() => setLoadingVariaveis(false));
    };

    const handleCopyKey = (key: string) => {
        navigator.clipboard.writeText(`clienteData.${key}`).then(() => {
            setCopiedKey(key);
            setTimeout(() => setCopiedKey(null), 1500);
        });
    };

    const handleRunPreview = () => {
        const mockupSelecionado = mockupPreview || mockupReferencia;
        if (!mockupSelecionado) {
            alert('Selecione um mockup para executar o preview.');
            return;
        }
        setPreviewRunning(true);
        setPreviewResult(null);
        const api = getApi();
        api.get(`test-case/mockup-preview/${mockupSelecionado.value}`).then((response: any) => {
            const mockupData = response.data?.mockup || {};
            const apiLocal = axios.create({ baseURL: 'http://127.0.0.1:4001' });
            return apiLocal.post('/execute-preview', {
                script: values.script || '',
                mockupData: mockupData,
                testCaseName: values.name || 'Preview'
            });
        }).then((response: any) => {
            setPreviewResult(response.data);
        }).catch((err: any) => {
            setPreviewResult({ success: false, message: 'Erro: ' + (err.message || 'verifique se o servidor Cypress está rodando na porta 4001.') });
        }).finally(() => {
            setPreviewRunning(false);
        });
    };

    const handleStartRecording = () => {
        if (!recordUrl || !recordUrl.startsWith('http')) {
            setRecordError('Informe uma URL válida (deve começar com http).');
            return;
        }
        setRecordError(null);
        setIsRecording(true);
        const apiLocal = axios.create({ baseURL: 'http://127.0.0.1:4001' });
        apiLocal.post('/start-recording', { url: recordUrl })
            .then((res: any) => {
                if (!res.data.success) { setIsRecording(false); setRecordError(res.data.message); }
            })
            .catch(() => { setIsRecording(false); setRecordError('Não foi possível conectar ao servidor Cypress (porta 4001).'); });
    };

    const handleStopRecording = () => {
        const apiLocal = axios.create({ baseURL: 'http://127.0.0.1:4001' });
        apiLocal.post('/stop-recording')
            .then((res: any) => {
                setIsRecording(false);
                if (res.data.success && res.data.script) {
                    setValues({...values, script: res.data.script, executorType: ExecutorType.SCRIPT});
                    setShowModalRecord(false);
                    setRecordError(null);
                } else {
                    setRecordError(res.data.message || 'Nenhum comando gravado.');
                }
            })
            .catch(() => { setIsRecording(false); setRecordError('Erro ao parar gravação.'); });
    };

    const handleCancelRecording = () => {
        const apiLocal = axios.create({ baseURL: 'http://127.0.0.1:4001' });
        apiLocal.post('/cancel-recording').finally(() => {
            setIsRecording(false); setShowModalRecord(false); setRecordError(null);
        });
    };

    const cabecalho = (
        <CCardHeader className="tester-form-cabecalho">
            <h1 className="tester-form-titulo">{titulo}</h1>
            {values.id && (
                <span className="tester-form-id" title="Identificador do caso de teste">
                    {isDuplicar ? 'cópia do #' + values.id : '#' + values.id}
                </span>
            )}
        </CCardHeader>
    );

    const rodape = (
        <CCardFooter className="tester-form-rodape">
            <CButton type="submit" color="primary">
                <CIcon name="cil-save" className="mr-1"/>Confirmar
            </CButton>
            <CButton type="button" color="secondary" variant="outline" onClick={() => history.goBack()}>
                Cancelar
            </CButton>
        </CCardFooter>
    );

    return <Form entity={'Caso de Teste ' + values.id} handleSubmit={aoSalvar} onFormReady={handleFormReady}
                 noValidate className="tester-form-caso" header={cabecalho} footer={rodape}>
        {isDuplicar && (
            <CAlert color="info">
                Você está criando uma cópia do caso #{values.id}. Revise o código e o nome antes de confirmar.
            </CAlert>
        )}

        <section className="tester-painel" aria-labelledby="dados-caso-titulo">
            <div className="tester-painel-cabecalho">
                <h2 id="dados-caso-titulo" className="tester-painel-titulo">Dados do caso</h2>
                <p className="tester-legenda-obrigatorio">* Campos obrigatórios</p>
            </div>
            <div className="row tester-dados-caso">
                <CFormGroup className="col-md-4 col-lg-2">
                    <CLabel className="tester-rotulo" htmlFor="codigo">
                        Código<span className="tester-obrigatorio" aria-hidden="true">*</span>
                    </CLabel>
                    <CInput type="text" id="codigo" name="codigo" maxLength={30} onChange={aoMudarCampo} value={values.codigo}
                            placeholder="Ex.: CT-012" required invalid={!!erros.codigo}
                            aria-describedby={erros.codigo ? 'codigo-erro' : undefined}/>
                    {erros.codigo && <CInvalidFeedback id="codigo-erro">{erros.codigo}</CInvalidFeedback>}
                </CFormGroup>
                <CFormGroup className="col-md-8 col-lg-4">
                    <CLabel className="tester-rotulo" htmlFor="name">
                        Nome<span className="tester-obrigatorio" aria-hidden="true">*</span>
                    </CLabel>
                    <CInput type="text" id="name" name="name" maxLength={100} onChange={aoMudarCampo} value={values.name}
                            required invalid={!!erros.name}
                            aria-describedby={erros.name ? 'name-erro' : undefined}/>
                    {erros.name && <CInvalidFeedback id="name-erro">{erros.name}</CInvalidFeedback>}
                </CFormGroup>
                <CFormGroup className="col-md-6 col-lg-3">
                    <CLabel className="tester-rotulo" htmlFor="groupTeste">Grupo de teste</CLabel>
                    <Select
                        inputId="groupTeste"
                        options={listGroupsTest}
                        onChange={handleGroupTest}
                        placeholder={'Sem grupo'}
                        isClearable
                        noOptionsMessage={() => 'Nenhum grupo encontrado'}
                        value={values.groupTeste?.value ? listGroupsTest.find((groupTeste: any) => groupTeste.value == values.groupTeste.value) || null : null}
                    ></Select>
                </CFormGroup>
                <CFormGroup className="col-md-6 col-lg-3">
                    <CLabel className="tester-rotulo" htmlFor="executorType">
                        Tipo de executor<span className="tester-obrigatorio" aria-hidden="true">*</span>
                    </CLabel>
                    <CSelect name="executorType" id="executorType" onChange={aoMudarCampo} value={values.executorType}
                             required invalid={!!erros.executorType}>
                        {ExecutorTypeList.map(item => (
                            <option key={item.value} value={item.value}>{item.description}</option>
                        ))}
                    </CSelect>
                    {erros.executorType && <CInvalidFeedback>{erros.executorType}</CInvalidFeedback>}
                </CFormGroup>
            </div>
        </section>

        {values.executorType === ExecutorType.SCRIPT ? (
            <section className="tester-painel" aria-labelledby="script-titulo">
                <div className="tester-painel-cabecalho">
                    <h2 id="script-titulo" className="tester-painel-titulo">Script do teste</h2>
                </div>
                <div className="row">
                    {/* ── EDITOR ── */}
                    <div className={mockupVariaveis ? 'col-md-8' : 'col-md-12'} style={{transition: 'all 0.2s'}}>
                        <CFormGroup>
                            <CLabel htmlFor="script" style={{fontWeight: 600, fontSize: '13px'}}>
                                Script Cypress
                            </CLabel>
                            <AceEditor
                                mode="javascript"
                                theme="github"
                                showGutter={true}
                                showPrintMargin={false}
                                highlightActiveLine={true}
                                width={'100%'}
                                minLines={20}
                                maxLines={40}
                                fontSize={13}
                                value={values.script || ''}
                                setOptions={{
                                    enableBasicAutocompletion: true,
                                    enableLiveAutocompletion: true,
                                    enableSnippets: false,
                                    showLineNumbers: true,
                                    tabSize: 2,
                                }}
                                onChange={(val: string) => setValues({...values, script: val})}
                                name="ace-script-editor"
                            />
                        </CFormGroup>
                    </div>

                    {/* ── PAINEL DE VARIÁVEIS ── */}
                    <div className={mockupVariaveis ? 'col-md-4' : 'col-md-12'}>
                        <CFormGroup>
                            <CLabel style={{fontWeight: 600, fontSize: '13px'}}>Mockup de Referência</CLabel>
                            <Select
                                options={listMockups}
                                onChange={handleMockupReferenciaChange}
                                placeholder={'Selecionar mockup...'}
                                value={mockupReferencia}
                                isClearable
                                styles={{
                                    control: (base: any) => ({...base, borderRadius: '6px', fontSize: '13px'}),
                                    option: (base: any) => ({...base, fontSize: '13px'}),
                                }}
                            />
                            {!mockupReferencia && (
                                <small style={{color: '#8a93a2', fontSize: '13px'}}>
                                    Selecione um mockup para ver as variáveis disponíveis no script
                                </small>
                            )}
                        </CFormGroup>

                        {loadingVariaveis && (
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                gap: '8px', padding: '24px', color: '#8a93a2', fontSize: '14px'
                            }}>
                                <span style={{animation: 'spin 1s linear infinite', display: 'inline-block'}}><CIcon name="cil-reload"/></span>
                                Compilando mockup...
                            </div>
                        )}

                        {mockupVariaveis && !loadingVariaveis && (() => {
                            const entries = Object.entries(mockupVariaveis).filter(([k]) =>
                                !filterVariaveis || k.toLowerCase().includes(filterVariaveis.toLowerCase())
                            );
                            return (
                                <div style={{
                                    border: '1px solid #e4e7ea',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    background: '#fff'
                                }}>
                                    {/* Header do painel */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #1f3c55 0%, #2d5986 100%)',
                                        padding: '10px 14px',
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                                    }}>
                                        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                            <span style={{color: '#fff', fontWeight: 600, fontSize: '14px'}}>
                                                {mockupReferencia?.label}
                                            </span>
                                        </div>
                                        <span style={{
                                            background: 'rgba(255,255,255,0.2)', color: '#fff',
                                            borderRadius: '12px', padding: '2px 10px', fontSize: '13px', fontWeight: 600
                                        }}>
                                            {Object.keys(mockupVariaveis).length} vars
                                        </span>
                                    </div>

                                    {/* Busca */}
                                    <div style={{padding: '8px 10px', borderBottom: '1px solid #e4e7ea', background: '#f8f9fa'}}>
                                        <input
                                            type="text"
                                            placeholder="Filtrar variável..."
                                            value={filterVariaveis}
                                            onChange={(e: any) => setFilterVariaveis(e.target.value)}
                                            style={{
                                                width: '100%', border: '1px solid #d8dbe0',
                                                borderRadius: '5px', padding: '5px 10px',
                                                fontSize: '13px', outline: 'none', background: '#fff'
                                            }}
                                        />
                                    </div>

                                    {/* Lista de variáveis */}
                                    <div style={{maxHeight: '420px', overflowY: 'auto'}}>
                                        {entries.length === 0 && (
                                            <div style={{padding: '16px', textAlign: 'center', color: '#8a93a2', fontSize: '13px'}}>
                                                Nenhuma variável encontrada
                                            </div>
                                        )}
                                        {entries.map(([key, value]: [string, any]) => {
                                            const isCopied = copiedKey === key;
                                            return (
                                                <div
                                                    key={key}
                                                    onClick={() => handleCopyKey(key)}
                                                    title={`Clique para copiar: clienteData.${key}`}
                                                    style={{
                                                        padding: '9px 14px',
                                                        borderBottom: '1px solid #f0f2f5',
                                                        cursor: 'pointer',
                                                        background: isCopied ? '#edf7ed' : '#fff',
                                                        transition: 'background 0.15s',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '3px',
                                                    }}
                                                    onMouseEnter={(e: any) => { if (!isCopied) e.currentTarget.style.background = '#f5f8ff'; }}
                                                    onMouseLeave={(e: any) => { if (!isCopied) e.currentTarget.style.background = '#fff'; }}
                                                >
                                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                                        <code style={{
                                                            fontSize: '13px',
                                                            color: isCopied ? '#2d8a4e' : '#3d6cb5',
                                                            fontWeight: 600,
                                                            background: isCopied ? '#d4edda' : '#eef3fc',
                                                            borderRadius: '4px',
                                                            padding: '2px 7px',
                                                            letterSpacing: '0.3px'
                                                        }}>
                                                            {isCopied ? <><CIcon name="cil-check" className="mr-1"/>copiado!</> : `clienteData.${key}`}
                                                        </code>
                                                        {!isCopied && (
                                                            <CIcon name="cil-copy" style={{fontSize: '13px', color: '#b0b7c3'}}/>
                                                        )}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        color: '#8a93a2',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '100%'
                                                    }}>
                                                        {String(value ?? '—').substring(0, 60)}{String(value ?? '').length > 60 ? '…' : ''}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Footer */}
                                    <div style={{
                                        padding: '7px 14px', background: '#f8f9fa',
                                        borderTop: '1px solid #e4e7ea',
                                        fontSize: '12px', color: '#b0b7c3', textAlign: 'center'
                                    }}>
                                        Clique em uma variável para copiar ao clipboard
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                </div>

                <CFormGroup className="mt-3">
                    <CButton color="warning" onClick={handleTestScript} style={{fontWeight: 600}} className="mr-2">
                        <CIcon name="cil-media-play" className="mr-1"/>Testar Script no Cypress
                    </CButton>
                    <CButton color="dark" variant="outline" onClick={() => { setShowModalRecord(true); setRecordError(null); }} style={{fontWeight: 600}}>
                        <CIcon name="cil-media-record" className="mr-1 text-danger"/>Gravar Interações
                    </CButton>
                </CFormGroup>
            </section>
        ) : (
            <TestCaseSteps
                operacoes={values.operations || []}
                onChange={(operacoes) => setValues({...values, operations: operacoes})}
                opcoes={listOperacoes}
                operacoesBase={listOperacoesBase}
                onEditar={onClickCustomOperation}
                idPasso={idOperacao}
            />
        )}

        <CModal
            show={showModalOperation}
            onClosed={onCloseModal}
            color="info"
            size={'lg'}
        >
            <CModalHeader closeButton>
                <CModalTitle className="text-truncate">Editar passo: {descreverOperacao(currentOperation["model"]).titulo}</CModalTitle>
            </CModalHeader>
            <CModalBody>
                {currentOperation["model"]["params"].type != TypeOperation.TYPE_CALL_URL
                    && currentOperation["model"]["params"].type != TypeOperation.TYPE_WAIT
                    && currentOperation["model"]["params"].type != TypeOperation.TYPE_EXECUTE_SCRIPT && <>
                        <CFormGroup>
                            <CLabel htmlFor="type_term">Tipo de Busca</CLabel>
                            <CSelect name="type_term" id="type_term" onChange={handleChangeCurrentOperation}
                                     value={valueTypeTerm}>
                                <option value=''>Selecionar...</option>
                                {TypeTermList.map(item => (
                                    <option key={item.value} value={item.value}>{item.description}</option>
                                ))}
                            </CSelect>
                        </CFormGroup>
                        <CFormGroup>
                            <CLabel htmlFor="value">Termo de Busca</CLabel>
                            <CInput type="text" id="value" name="value"
                                    onChange={handleChangeCurrentOperation}
                                    value={valueValue}/>
                        </CFormGroup>
                    </>}
                <CFormGroup className="mb-0">
                    <CLabel htmlFor="data">Parâmetro/Valor para Operação</CLabel>
                    {/* Sem limite de tamanho: o valor fica no JSON do caso, e um execute_script passa fácil de 100 caracteres */}
                    {currentOperation["model"]["params"].type == TypeOperation.TYPE_EXECUTE_SCRIPT
                        ? <CTextarea id="data" name="data" rows={8} onChange={handleChangeCurrentOperation}
                                     value={valueData} style={{fontFamily: 'monospace', fontSize: '.85rem'}}/>
                        : <CInput type="text" id="data" name="data" onChange={handleChangeCurrentOperation} value={valueData}/>}
                </CFormGroup>
            </CModalBody>
            <CModalFooter>
                <CButton color="secondary" variant="outline" onClick={onCloseModal}>Cancelar</CButton>
                <CButton color="primary" onClick={onConfirmeOperation}>Aplicar</CButton>
            </CModalFooter>
        </CModal>

        <CModal show={showModalPreview} onClosed={() => { setShowModalPreview(false); setPreviewResult(null); }} size={'lg'}>
            <CModalHeader closeButton>
                <CModalTitle>Testar Script no Cypress</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="p-2">
                    <CFormGroup>
                        <CLabel>Mockup para execução:</CLabel>
                        <Select
                            options={listMockups}
                            onChange={(opt: any) => setMockupPreview(opt)}
                            placeholder={'Selecionar mockup...'}
                            value={mockupPreview || mockupReferencia}
                        />
                        {mockupReferencia && !mockupPreview && (
                            <small className="text-muted">Pré-selecionado com base no Mockup de Referência</small>
                        )}
                    </CFormGroup>
                    <CFormGroup>
                        <CButton color="warning" onClick={handleRunPreview} disabled={previewRunning}>
                            {previewRunning
                                ? <><CIcon name="cil-reload" className="mr-1"/>Executando...</>
                                : <><CIcon name="cil-media-play" className="mr-1"/>Executar no Cypress</>
                            }
                        </CButton>
                    </CFormGroup>
                    {previewResult && (
                        <div className={`alert ${previewResult.success ? 'alert-success' : 'alert-danger'}`}>
                            <strong>{previewResult.success ? 'Execução concluída' : 'Falha na execução'}:</strong> {previewResult.message}
                        </div>
                    )}
                    <small className="text-muted d-block mt-2">
                        O servidor Cypress deve estar rodando na porta 4001. O teste abrirá em modo headed (janela visível).
                    </small>
                </div>
            </CModalBody>
        </CModal>

        {/* ── MODAL DE GRAVAÇÃO ── */}
        <CModal show={showModalRecord} onClosed={handleCancelRecording} size={'lg'}>
            <CModalHeader closeButton>
                <CModalTitle>
                    <CIcon name="cil-media-record" className="mr-2"/>
                    Gravar Interações → Script Cypress
                </CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="p-2">
                    {!isRecording ? (
                        <>
                            <div style={{
                                background: 'linear-gradient(135deg, #1f3c55 0%, #2d5986 100%)',
                                borderRadius: '8px', padding: '16px 20px', marginBottom: '20px', color: '#fff'
                            }}>
                                <div style={{fontWeight: 700, fontSize: '15px', marginBottom: '8px'}}>Como funciona:</div>
                                <ol style={{margin: 0, paddingLeft: '18px', fontSize: '13px', lineHeight: '1.8'}}>
                                    <li>Informe a URL inicial do site a ser testado</li>
                                    <li>Clique em <strong>"Iniciar Gravação"</strong> — o Chrome abrirá automaticamente</li>
                                    <li>Navegue e interaja normalmente com o site</li>
                                    <li>Clique em <strong>"Parar e Importar"</strong> quando terminar</li>
                                    <li>O script gerado será inserido no editor automaticamente</li>
                                </ol>
                            </div>

                            <CFormGroup>
                                <CLabel style={{fontWeight: 600}}>URL inicial</CLabel>
                                <CInput
                                    type="url"
                                    placeholder="https://exemplo.com ou http://cliente-sprint.panoramasistemas.dev.br"
                                    value={recordUrl}
                                    onChange={(e: any) => setRecordUrl(e.target.value)}
                                />
                                {mockupReferencia && mockupVariaveis?.cliente_url && (
                                    <small
                                        className="text-primary"
                                        style={{cursor: 'pointer'}}
                                        onClick={() => setRecordUrl(mockupVariaveis.cliente_url)}
                                    >
                                        <CIcon name="cil-arrow-right" className="mr-1"/>Usar URL do mockup: <strong>{mockupVariaveis.cliente_url}</strong>
                                    </small>
                                )}
                            </CFormGroup>

                            {recordError && (
                                <div className="alert alert-danger">{recordError}</div>
                            )}

                            <CButton color="danger" onClick={handleStartRecording} style={{fontWeight: 600}}>
                                <CIcon name="cil-media-record" className="mr-1"/>Iniciar Gravação
                            </CButton>
                        </>
                    ) : (
                        <div style={{textAlign: 'center', padding: '24px 0'}}>
                            <div style={{
                                width: '64px', height: '64px', borderRadius: '50%',
                                background: 'radial-gradient(circle, #ff4444 0%, #cc0000 100%)',
                                margin: '0 auto 20px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                boxShadow: '0 0 0 0 rgba(255,68,68,0.7)',
                                animation: 'pulse-rec 1.5s infinite',
                                fontSize: '28px'
                            }}>
                                <CIcon name="cil-media-record" style={{color: '#fff', width: '28px', height: '28px'}}/>
                            </div>
                            <div style={{fontWeight: 700, fontSize: '18px', marginBottom: '6px'}}>Gravando...</div>
                            <div style={{color: '#6c757d', fontSize: '14px', marginBottom: '28px'}}>
                                Interaja com o browser que foi aberto.<br/>
                                Cada clique e digitação está sendo capturado.
                            </div>
                            {recordError && (
                                <div className="alert alert-danger">{recordError}</div>
                            )}
                            <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                                <CButton color="success" onClick={handleStopRecording} style={{fontWeight: 600, padding: '10px 28px'}}>
                                    <CIcon name="cil-media-stop" className="mr-1"/>Parar e Importar Script
                                </CButton>
                                <CButton color="secondary" onClick={handleCancelRecording} style={{fontWeight: 600}}>
                                    Cancelar
                                </CButton>
                            </div>
                        </div>
                    )}
                </div>
            </CModalBody>
        </CModal>
    </Form>
}
export default TestCaseForm;